import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store/store';

Vue.use(VueRouter);

/**
 * Vue Router instance configured for the application.
 *
 * Main configuration:
 * - mode: 'history' (uses the browser History API)
 * - routes: route definitions imported from './routes'
 * - linkActiveClass: CSS class applied to active links
 * - scrollBehavior: function to control scroll position on navigation
 *
 * @type {import('vue-router').Router}
 */
const router = new VueRouter({
    mode: 'history',
    routes,
    linkActiveClass: 'active',
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    }
});

/**
 * Global navigation guard executed before every route change.
 *
 * This guard reads credentials from Vuex (getter `sesion`) and decides
 * whether to allow or block navigation based on the route meta fields
 * `requiresAuth` and `roles` defined on routes.
 *
 * @param {import('vue-router').Route} to - Destination route.
 * @param {import('vue-router').Route} from - Current route.
 * @param {Function} next - Callback to resolve the navigation:
 *   - next() -> continue
 *   - next(false) -> abort and stay on current route
 *   - next('/path') -> redirect to another route
 * @returns {Promise<void>|void} May return a promise if async operations are performed.
 */
router.beforeEach(async (to, from, next) => {
    let credentials = store.getters.sesion;
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!credentials) {
            return next({
                path: '/signin',
                query: { redirect: to.fullPath }
            })
        } else {
            const roles = (to.meta.roles) ? to.meta.roles : [];
            if (roles.includes(credentials.role)) {
                return next()
            }
        }
        return next('/404')
    } else {
        if (to.path === "/signin" && from.path === "/reservations") {
            if (!credentials) {
                return next();
            }
            return next(false);
        }
        return next()
    }
})

export default router;